import {cacheBellSounds} from "./BellSoundCache";

export const BELL_INFO_STORAGE_KEY = "bellInfo";
export const BELL_INFO_UPDATED_EVENT = "bell:info-updated";

export const readBellInfo = () => {
    try {
        const data = JSON.parse(localStorage.getItem(BELL_INFO_STORAGE_KEY));
        return Array.isArray(data) ? data : [];
    } catch (e) {
        console.error("Error while reading bell info from local storage:", e);
        return [];
    }
};

export const notifyBellInfoUpdated = (bellInfo = readBellInfo()) => {
    window.dispatchEvent(
        new CustomEvent(BELL_INFO_UPDATED_EVENT, {
            detail: {
                bellInfo,
                updatedAt: Date.now(),
            },
        })
    );
};

// Pass {force: true} after a bell add/replace so cached audio is re-downloaded
// even when it lives at the same R2 URL. Plain reads (e.g. login) omit it and
// keep the cheap "skip already-cached" behaviour.
export const setBellInfo = (bellInfo = [], {force = false} = {}) => {
    const nextBellInfo = Array.isArray(bellInfo) ? bellInfo : [];
    localStorage.setItem(BELL_INFO_STORAGE_KEY, JSON.stringify(nextBellInfo));
    notifyBellInfoUpdated(nextBellInfo);
    // First priority: pre-fetch every bell's R2 file and cache it locally so
    // playback stays reliable even when the network drops. Fire-and-forget —
    // it never throws and must not block login / save / update.
    cacheBellSounds(nextBellInfo, {force});
};
